import React, { Component } from 'react';
import RankingPanel from './rankingPanel';

class GameResult extends Component {
  render() {
    return (
      <RankingPanel rankingList = {this.props.rankingList}></RankingPanel>
    );
  }
}

export default GameResult;



// WEBPACK FOOTER //
// ./src/components/gameResult.js